import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GALLERY_KEY, IGalleryState } from '../models/gallery.model';

const selectFeature = createFeatureSelector<IGalleryState>(GALLERY_KEY);

export const selectGalleryData = createSelector(selectFeature, (state: IGalleryState) => state);
